import {
  GET_CHAPTER_LIST,
  GET_COURSES_LIST,
  GET_SUBJECT_LIST,
} from "utils/graphql/services/global-content-hierarchy/queries";
import * as Yup from "yup";

export type courseClassSubChapMapFilter = {
  global_course_id: string;
  global_subject_id: string;
  global_chapter_id: string;
  status: string;
  class_id: string;
};

export const courseClassSubChapMapFilterInitialValues: courseClassSubChapMapFilter =
  {
    global_course_id: "",
    global_subject_id: "",
    global_chapter_id: "",
    status: "",
    class_id: "",
  };

export const courseClassSubChapMapFilterMandatoryFields = [];

export const courseClassSubChapMapFilterValidationSchema =
  Yup.object().shape({});

export const courseClassSubChapMapFilterProperties = [
  {
    id: "class_id",
    type: "single-select-dependency",
    label: "Class",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
    dependentFields: [""],
    dependentFlds: {},
  },
  {
    id: "global_course_id",
    type: "normal-select-search-only",
    label: "Course",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_fil_course_list",
    keyValue: { label: "course_name", value: "id" },
    query: GET_COURSES_LIST,
    gqlKey: "getCourses",
    searchFieldKey: "course_name",
    mandatoryIds: ["gcf_public_course_id","npractice_practice_program_id"],
  },
  {
    id: "global_subject_id",
    type: "normal-select-search-only",
    label: "Subject",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_fil_subject_list",
    keyValue: { label: "global_name", value: "id" },
    query: GET_SUBJECT_LIST,
    gqlKey: "getSubjects",
    searchFieldKey: "global_name",
    mandatoryIds:["gcf_public_subject_id", "npractice_practice_subject_id"],
  },
  {
    id: "global_chapter_id",
    type: "normal-select-search-only",
    label: "Chapter",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_fil_chapter_list",
    keyValue: { label: "global_name", value: "id" },
    query: GET_CHAPTER_LIST,
    gqlKey: "getChapters",
    searchFieldKey: "global_name",
    mandatoryIds:["gcf_public_chapter_id", "gcf_learn_chapter_id", "npractice_practice_chapter_id"],
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];
